import { Form, Formik } from 'formik'
import React from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import Button from '../../../../../components/buttons/buttons.component'
import {
	CPFInput,
	NumberInput,
	SelectInput,
	TextInput
} from '../../../../../components/form-components/inputs.component'
import STATES from './../../../../register/states'
import StyledFlexContainer from '../../../../../components/containers/flex-container.component.jsx'

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 2.7rem;
`

const schema = Yup.object().shape({})

class SearchForm extends React.Component {
	render() {
		return (
			<div>
				<Formik
					initialValues={initialValues}
					onSubmit={this.props.onSubmit}
					validationSchema={schema}
					render={formikRender}
				/>
			</div>
		)
	}
}

function formikRender(props) {
	return (
		<Form className="form" noValidate>
			<StyledFlexContainer>
				<TextInput
					className={'col-6'}
					id="name"
					label="Nome"
					maxLength={128}
					autoFocus={true}
					{...props}
				/>
				<NumberInput
					className={'col-4'}
					id="moveflexNumber"
					label="Número Muviflex"
					maxLength={38}
					{...props}
				/>
				<SelectInput
					className={'col-2'}
					id="hasMuvicard"
					label="Possui Muvicard"
					defaultValue={muvicardDefaultValue}
					options={muvicardOptions}
					multi={false}
					{...props}
				/>
			</StyledFlexContainer>
			<StyledFlexContainer>
				<CPFInput className={'col-4'} id="cpf" label="CPF" {...props} />
				<TextInput
					className={'col-4'}
					id="city"
					label="Cidade"
					maxLength={38}
					{...props}
				/>
				<SelectInput
					className={'col-2'}
					id="state"
					label="UF"
					defaultValue={ufDefaultValue}
					options={stateOptions}
					multi={false}
					{...props}
				/>
				<SelectInput
					className={'col-2'}
					id="active"
					label="Situação"
					defaultValue={activeDefaultValue}
					options={statusOptions}
					multi={false}
					{...props}
				/>
			</StyledFlexContainer>
			<StyledButtonContainer>
				<Button
					data-permission="6EC278D8BBAD4022FB5A1EA6D295285E69896208"
					primary
					type="submit">
					Consultar
				</Button>
			</StyledButtonContainer>
		</Form>
	)
}

const stateOptions = [{ value: 'none', label: 'Todas' }].concat(
	STATES.map(({ Nome, Sigla }) => ({
		value: Sigla,
		label: Nome
	}))
)

const statusOptions = [
	{ value: 'none', label: 'Todos' },
	{ value: 'true', label: 'Ativos' },
	{ value: 'false', label: 'Inativos' }
]

const muvicardOptions = [
	{ value: 'ALL', label: 'Todos' },
	{ value: 'YES', label: 'Sim' },
	{ value: 'NO', label: 'Não' }
]

const initialValues = {
	active: 'true',
	city: '',
	cpf: '',
	moveflexNumber: '',
	name: '',
	state: '',
	hasMuvicard: 'ALL'
}

const ufDefaultValue = { value: 'none', label: 'Todas' }
const activeDefaultValue = { value: 'active', label: 'Ativos' }
const muvicardDefaultValue = { value: 'ALL', label: 'Todos' }

export default SearchForm
